import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'contact',
  `
    RESET_ATTEMPT_ID
  `
);
